import type { AnalyticsInstance } from 'analytics';

type AnalyticsWindowT = { analytics?: AnalyticsInstance; } & Window;

declare let window: AnalyticsWindowT;

// The `analytics` instance lives in each app (e.g. apps/account-home/src/utils/adobe-analytics.ts,
// apps/contract/src/utils/analytics/index.ts) and is exposed on `window.analytics`.
export const resetAnalytics = (): void => {
  window.analytics?.reset();
};
